<template>
  <div class="flex flex-col gap-1 w-full">
    <div
      v-if="this.type === 'MIXED'"
      class="grid grid-cols-2 w-full justify-between gap-2"
    >
      <vs-button
        class="w-full text-sm font-normal"
        :class="this.activeTab === 'BLENDING' ? 'btn-active' : 'btn-inactive'"
        @click="changeTabTo('BLENDING')"
      >
        BLENDING
      </vs-button>
      <vs-button
        class="w-full text-sm font-normal"
        :class="this.activeTab === 'STORAGE' ? 'btn-active' : 'btn-inactive'"
        @click="changeTabTo('STORAGE')"
      >
        STORAGE
      </vs-button>
    </div>
    <div
      v-show="activeTab === 'BLENDING'"
      v-if="type !== 'STORAGE'"
      class="w-full"
    >
      <tbs-blending-calculator 
        :is-edit-mode="isEditMode"
        :tbs-data-list="this.tbsDataList"
        :loading-plan-list="this.loadingPlanList.filter(v => !v.loading_facility || v.loading_facility.type !== 'STORAGE')"
        :set-error-list="this.setErrorListBlending"
        :set-payload-blending="this.setPayloadBlending"
        :tbs-header-id="this.tbsHeaderId"
      />
    </div>
    <div
      v-show="activeTab === 'STORAGE'"
      v-if="type !== 'BLENDING'"
      class="w-full"
    >
      <tbs-storage-calculator
        :is-edit-mode="isEditMode"
        :tbs-data-list="this.tbsDataList"
        :loading-plan-list="this.loadingPlanList.filter(v => v.loading_facility && v.loading_facility.type === 'STORAGE')"
        :set-error-list="this.setErrorListStorage"
        :set-payload-storage="this.setPayloadStorage"
        :tbs-header-id="this.tbsHeaderId"
      />
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

import TBSStorageCalculator from '@/views/vesselLineUp/tentativeBargeSchedule/components/TbsStorageCalculator.vue'

import TbsBlendingCalculator from './TbsBlendingCalculator.vue'

export default {
  components: { TbsStorageCalculator: TBSStorageCalculator,TbsBlendingCalculator },
  watch: {
    tbsList: {
      immediate: true,
      deep: true,
      handler(val) {
        this.tbsDataList = [...val]
      }
    },
    type: {
      immediate: true,
      handler(val) {
        if(val !== 'MIXED') {
          this.activeTab = val
        }
      }
    },
    errorsStorage: {
      immediate: true,
      deep: true,
      handler(val) {
        this.errors = _.concat(val, this.errorsBlending)
      }
    },
    errorsBlending: {
      immediate: true,
      deep: true,
      handler(val) {
        this.errors = _.concat(val, this.errorsStorage)
      }
    },
    errors: {
      deep: true,
      handler(val) {
        this.setErrorList(val)
      }
    },
    isEditMode: {
      immediate: true,
      handler(val) {
        if(!val) {
          this.errorsStorage = [],
          this.errorsBlending = []
        }
      }
    }
  },
  data() {
    return {
      activeTab: 'BLENDING',
      tabs: ['BLENDING', 'STORAGE'],
      tbsDataList: [],
      errors: [],
      errorsStorage: [],
      errorsBlending: []
    }
  },
  methods: {
    changeTabTo(tabName) {
      this.activeTab = tabName
    },
    setErrorListStorage(list) {
      this.errorsStorage = list
    },
    setErrorListBlending(list) {
      this.errorsBlending = list     
    }
  },
  props: {
    type: {
      type: String,
      default: () => 'MIXED'
    },
    isEditMode: {
      type: Boolean,
      default: () => false
    },
    tbsHeaderId: {
      type: Number,
      default: () => null
    },
    loadingPlanList: {
      type: Array,
      default: () => []
    },
    tbsList: {
      type: Array,
      default: () => []
    },
    setErrorList: {
      type: Function,
      default: () => {}
    },
    setPayloadStorage: {
      type: Function,
      default: () => {}
    },
    setPayloadBlending: {
      type: Function,
      default: () => {}
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-inactive {
  border-color: #DEDEDE;
  background-color: #DEDEDE !important;
  color: #676767;
}
.btn-active {
  border-color: #836ADA;
  background-color: #836ADA !important;
  color: white;
}
</style>